import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { WindowReferenceService, ICustomWindow } from '@core/shared';
import { AccountsService } from '../services/accounts.service';
import { AuthenticationService } from '@core/startup';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { browserRefresh } from '@app/app.component';
import { PreloginService } from '@app/core/prelogin/services';
import { uniqueFieldValidation } from '@app/extension/models/userAddressDetail.model';
let windowObject = window as any;

@Component({
  selector: 'app-edit-profile-selfregistration',
  template: `<div class="both"> <div id="selfRegistrationRoot" class="common-prelogin-form card card-signin changepassword-inner selfRegister-body"> <div class="both"></div></div>`
})
export class EditProfileSelfRegistrationComponent implements OnInit, OnDestroy {

  private _window: ICustomWindow;
  public userId: string;
  selectedCulture: string;
  languageChangeSubscription: Subscription;
  navigationStartSubscription: Subscription;
  browserRefresh: boolean;
  jobRoleList:any;

  constructor(public accountsService: AccountsService, public windowRef: WindowReferenceService, public authService: AuthenticationService, 
    private translateService: TranslateService, private router: Router, private preloginService:PreloginService) {
    this._window = windowRef.nativeWindow;
  }
  ngOnInit(): void {

    this.preloginService.getJobRoles().subscribe(res => {
      this.jobRoleList = res;
      sessionStorage.setItem("JobRoles",JSON.stringify(res));
    });

    windowObject.parent.preloginService = this.preloginService;
    windowObject.parent.translate = this.translateService;

    windowObject.parent.preRegistrationCallBack = function (userDetails): Promise<any> {
      let panObject:any = Object.values(userDetails).find(x => x["fieldName"] == "PAN Number");
      let gstObject:any = Object.values(userDetails).find(x => x["fieldName"] == "GST Number");
      let addressObject:any = Object.values(userDetails).find(x => x["fieldName"] == "Address");
      let jobRolebject:any = Object.values(userDetails).find(x => x["fieldName"] == "Job Role");
      let emailObject:any = Object.values(userDetails).find(x => x["fieldName"] == "Email");
      let mobileObject:any = Object.values(userDetails).find(x => x["fieldName"] == "Mobile Phone");
      let campaignObject:any = Object.values(userDetails).find(x => x["fieldName"] == "Campaign Name");
      let userObject:any = Object.values(userDetails).find(x => x["fieldName"] == "User Name");
      let organisationObject:any = Object.values(userDetails).find(x => x["fieldName"] == "Firm Name");
     
      const promise = new Promise((resolve, reject) => {
        var random = Math.floor(Math.random() * Math.floor(100000000));
        var response = {
          "success": true,
          "errorCode": "",
          "responseMessage": "",
          "customAttributes": {
            
          }
        };
        let isError = false;let errorMsg = '';
        let region = ''; let district = '';let hierarchyGroupId = '';
        let programName = sessionStorage.getItem("programName");
        let campaignId:any = '';

       

        if(jobRolebject){
          this.jobRoleList = JSON.parse(sessionStorage.getItem("JobRoles")) ;
          let jobRoleId = jobRolebject.fieldValue.toUpperCase();
          let jobRoleName = this.jobRoleList.listViews.find(x => x.value.toUpperCase() == jobRoleId)?.name;
          if(jobRoleName == 'Distributor' || jobRoleName == 'Channel Partner'){

            if(!panObject || panObject.fieldValue == ""){
              isError = true;
              errorMsg = windowObject.parent.translate.instant("SelfRegistration.PANRequired");
              // response.success = false;
              // response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.PANRequired");
              // reject(response);
            }
            else if(!gstObject || gstObject.fieldValue == ""){
              isError = true;
              errorMsg = windowObject.parent.translate.instant("SelfRegistration.GSTRequired");
              // response.success = false;
              // response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.GSTRequired");
              // reject(response);
            }
          }else if (jobRoleName == 'Retailer' || jobRoleName == 'Sub Dealer' ||
          jobRoleName == 'Contractor' || jobRoleName == 'Store Manager' ||
          jobRoleName == 'Service Advisors' || jobRoleName == 'Car Dealership Centre' ||
          jobRoleName == 'Dealership Manager' || jobRoleName == 'Supervisor') {
            if (!panObject || panObject.fieldValue == "") {
              isError = true;
              errorMsg = windowObject.parent.translate.instant("SelfRegistration.PANRequired");
              // response.success = false;
              // response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.PANRequired");
              // reject(response);
            }
          }
        }

        if (!isError){
          // let model = new userAddress();
          // model.city = addressObject.value.city;
          // model.state = addressObject.value.state;

          let uniqueValidate = new uniqueFieldValidation();
          uniqueValidate.programName = programName;
          uniqueValidate.gstNumber = gstObject?.fieldValue;
          uniqueValidate.panNumber = panObject?.fieldValue;
          //uniqueValidate.mobileNumber = mobileObject?.fieldValue.phoneNumber;
          //uniqueValidate.eMailId = emailObject?.fieldValue;
          uniqueValidate.updateUserName = userObject?.fieldValue;
          uniqueValidate.isUserUpdate = true;

          windowObject.parent.preloginService.checkUniqueDataValidation(uniqueValidate).subscribe((validationResponse)=>{
            if(isError){
              response.success = false;
              response.responseMessage = errorMsg;
              reject(response);
            }else{
              response.responseMessage = JSON.stringify(userDetails)
              resolve(response);
            }
          },
          (err)=>{
              response.success = false;
              if (err.error && err.error.modelState) {
                Object.keys(err.error.modelState).forEach(key => {
                  let errorKey = key.charAt(0).toUpperCase() + key.slice(1)
                  response.responseMessage = windowObject.parent.translate.instant(errorKey);
                });
              }else{
                response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.RequiredFieldValidation");
              }
              reject(response);
            }
          );
        }
        else if(isError){
          response.success = false;
          response.responseMessage = errorMsg; 
          reject(response);
        }
        else{
          response.responseMessage = JSON.stringify(userDetails)
          resolve(response);
        }
       
       
       });
      return promise;
    };

    windowObject.parent.postRegistrationCallBack = (userDetails, message) => {
      location.reload();
    };    

    this.navigationStartSubscription = this.router.events.pipe(
      filter((event: RouterEvent) => event instanceof NavigationEnd),
      startWith('Initial call')
    ).subscribe((res) => {
      this.browserRefresh = browserRefresh;
      this.getUser();
    });

    this.languageChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      if (!this.browserRefresh) {
        //this.getConfig();        
        window.location.reload();
      }
      else
        this.browserRefresh = false;
    });
  }

  getUser() {
    this.selectedCulture = localStorage.getItem('culture');
    this.authService.getCurrentUser().subscribe(response => {
      this.userId = response.id;
      this.accountsService.selfRegistrationConfig().subscribe(data => {
        this.renderForm(data);
      })
    });
  } 

  renderForm(configs) {
    this.accountsService.editProfileSelfRegistration(configs, this.userId, this.selectedCulture).subscribe(data => {
      this._window.__selfRegistrationAppData__ = data;
      this._window.loadSelfRegistrationInDom('selfRegistrationRoot');
    });
  }

  ngOnDestroy() {
    if (this.languageChangeSubscription)
      this.languageChangeSubscription.unsubscribe();
    if (this.navigationStartSubscription)
      this.navigationStartSubscription.unsubscribe();
  }
}
